
const initialState = {
    insuranceAmount : 90000,
    smaffPackages: [
        {
            "name": "Baspaketet",
            "id": 1
        },
        {
            "name": "Stora paketet",
            "id": 2
        }
    ],
    // selectedSmaffPackage: null
    selectedSmaffPackage: 2
};

export default (state = initialState, action) => {
    switch (action.type) {

        case 'SET_PRODUCT_SUCCESS': {

            return {
                ...state,
            }
        }
        case 'SET_SELECTED_PACKAGE_SUCCESS': {

            return Object.assign({}, state, {
                'selectedSmaffPackage': action.data,
            });

        }
        case 'SET_INSURANCE_AMOUNT_SUCCESS': {

            return Object.assign({}, state, {
                'insuranceAmount': action.data,
            });

        }

        default:
            return state
    }
}
